import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SearchService } from '../../services/search.service';
import { TranslationService } from '../../services/translation.service';
import { TrendingTerm } from '../../models/trending-term.model';

/**
 * "Cautari populare" - randat sub bara de cautare de pe prima pagina, cand
 * userul n-a tastat nimic inca (exact ca randul de sugestii de sub bara de
 * cautare Google, sau "Popular Right Now" din App Store). Lista vine din
 * /search/trending, care pondereaza termenii cu click-uri reale mai mult
 * decat pe cei doar cautati, si ascunde orice termen vazut de prea putini
 * cetateni (vezi analytics/trending.js pentru pragul de k-anonimitate).
 */
@Component({
  selector: 'app-trending-searches',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './trending-searches.component.html',
  styles: [`
    .trending-searches {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.5rem;
      margin-top: 0.75rem;
      padding: 0 0.25rem;
    }

    .trending-searches-title {
      font-size: 0.85rem;
      color: #666;
      margin-right: 0.25rem;
      flex: 0 0 auto;
    }

    .trending-searches-chips {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
    }

    .trending-chip {
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
      border: 1px solid #ddd;
      background: #fff;
      border-radius: 999px;
      padding: 0.3rem 0.75rem;
      font-size: 0.85rem;
      cursor: pointer;
      color: #333;
      transition: background-color 0.15s ease, border-color 0.15s ease;
      max-width: 220px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .trending-chip:hover {
      background: #f2f2f2;
      border-color: #bbb;
    }

    .trending-chip-icon {
      font-size: 1rem;
      line-height: 1;
    }

    .trending-chip-label {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `]
})
export class TrendingSearchesComponent implements OnInit {
  @Output() termSelected = new EventEmitter<string>();

  terms: TrendingTerm[] = [];
  loaded = false;

  constructor(
    private readonly searchService: SearchService,
    private readonly translation: TranslationService
  ) {}

  ngOnInit(): void {
    this.searchService.getTrending(8).subscribe({
      next: response => {
        this.terms = response?.items ?? [];
        this.loaded = true;
      },
      error: () => {
        this.terms = [];
        this.loaded = true;
      }
    });
  }

  get title(): string {
    return this.translation.translate('trendingSearchesTitle');
  }

  onTermClick(term: string): void {
    this.termSelected.emit(term);
  }
}
